/** @format */

import { Component, computed, inject, input, model } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import {
	HmfAlertBannerComponent,
	HmfDropdownSelect,
	HmfSelectComponent,
	HmfSelectorComponent,
	HmfSkeletonComponent,
	HmfTextLinkComponent
} from '@dsg-tech/homefield-angular';
import { Warranty } from '@pdp/data-access/interfaces';
import { NoPlanKey, NoPlanLabel } from './warranty-plan-selector.constants';

@Component({
	selector: 'pdp-component-warranty-plan-selector',
	imports: [
		CommonModule,
		HmfSkeletonComponent,
		HmfSelectorComponent,
		HmfSelectComponent,
		HmfAlertBannerComponent,
		HmfTextLinkComponent
	],
	providers: [CurrencyPipe],
	templateUrl: './warranty-plan-selector.component.html',
	styleUrl: './warranty-plan-selector.component.scss'
})
export class WarrantyPlanSelectorComponent {
	currencyPipe = inject(CurrencyPipe);

	isLoading = input.required<boolean>();
	isError = input.required<boolean>();
	warranties = input.required<Warranty[]>();
	// undefined -> no selection yet, null -> no plan selected
	selectedPlanSku = model.required<number | undefined | null>();

	hmfSelectOptions = computed(() => {
		if (this.warranties().length < 4) {
			return [];
		}
		return this.warranties()
			.map((warranty) => ({
				key: warranty.planSku.toString(),
				label: `${warranty.planDisplayName} - ${this.currencyPipe.transform(warranty.sellingPrice)}`,
				selected: warranty.planSku === this.selectedPlanSku()
			}))
			.concat({
				key: NoPlanKey,
				label: NoPlanLabel,
				selected: this.selectedPlanSku() === null
			});
	});

	handleHmfSelectChange(selectedValue: HmfDropdownSelect) {
		if (selectedValue.key === NoPlanKey) {
			this.selectedPlanSku.set(null);
		} else {
			this.selectedPlanSku.set(parseInt(selectedValue.key, 10));
		}
	}
}
